import { IKid, ISelfResponse } from '@/shared/interfaces';
import { atom } from 'jotai/index';
import { Utils } from '@/shared/Utils';
// Backing atom that holds the ISelfResponse we get from the server
export const profileAtom = atom<ISelfResponse | null>();
// Derived atom that transforms ISelfResponse -> IPatientDto[]
export const kidsAtom = atom((get) => {
    const response = get(profileAtom);
    if (!response?.Kids) return null;

    const kids: IKid[] = response.Kids?.map((kid) => {
        return {
            Name: kid.User.FullName,
            UID: kid.User.UID,
            CPR: kid.CPR,
            FormattedCpr: Utils.formatCpr(kid.CPR),
        };
    });
    return kids;
});
